import { useContext } from 'react';

import { AuthContext } from './AuthContext';

export function useIsLoggedIn() {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated;
}
